import * as React from 'react';
import { getFormattedSpendWithSymbol } from 'utils/number';

import { Wrapper, Row, Color, Title, Range, Value } from './styles';

export const ChartMenu = props => {
	const { data, currencySymbol } = props;
	const sum = data.reduce((acc, item) => acc + item.value, 0);

	return (
		<Wrapper>
			{data.map(item => (
				<Row key={item.name}>
					<Color color={item.color} />
					<Title>{item.name}</Title>
					<Range>({Math.round((item.value / sum) * 1000) / 10}%)</Range>
					<Value>
						{item.value
							? getFormattedSpendWithSymbol(
									item.value,
									currencySymbol
							  ).toUpperCase()
							: '-'}
					</Value>
				</Row>
			))}
		</Wrapper>
	);
};
